import React from "react";
import { useIntl } from "react-intl";
import { PICKER_LIMIT } from "../utils/constants";
/**
 * Shown under a search-as-you-type picker whose search returned a full page (DB-876): more records match than the
 * picker lists, so the user should type more.
 */
export var PickerHint = function (_a) {
    var truncated = _a.truncated;
    var formatMessage = useIntl().formatMessage;
    if (!truncated)
        return null;
    return (React.createElement("div", { role: "status", style: { fontSize: "0.85em", opacity: 0.8 } }, formatMessage({ id: "ui-br-users.picker.refineSearch" }, { count: PICKER_LIMIT })));
};
